export default {
  theme: {
    light: "Светлая",
    dark: "Тёмная",
    switchToLight: "Включить светлую тему",
    switchToDark: "Включить тёмную тему",
  },
  routes: {
    title: "Маршруты",
    viewList: "Списком",
    viewMap: "На карте",
    count: "Маршрутов: {n}",
    empty: "Под фильтры ничего не подошло",
    reset: "Сбросить фильтры",
    gradeFilter: "Фильтр по сложности",
    durationFilter: "Длительность",
    shape: { label: "Форма", loop: "Кольцевой", linear: "В одну сторону" },
    source: { label: "Источник", all: "Все", curated: "EcoWay", community: "От пользователей", communityBadge: "От пользователя · не проверен EcoWay", verified: "Проверено EcoWay", unverified: "От пользователя, не проверен EcoWay", author: "Автор", unverifiedShort: "не проверен EcoWay" },
    distanceLabel: "Расстояние:",
    distanceFromYou: "от вас",
  },
  safety: {
    nearestShelters: "Ближайшие укрытия",
    nearestSheltersHint: "Спасательные хижины МЧС рядом с вами - от ближайшей.",
    sheltersQuery: "Спасательные хижины",
    title: "Безопасность",
    loggedOutTitle: "Войдите, чтобы регистрировать выходы",
    loggedOutBody: "Регистрация выхода сообщает близким и спасателям, куда вы пошли и когда ждать вас обратно.",
    noTrip: "Нет активного выхода",
    registerCta: "Зарегистрировать выход",
    returnBy: "вернуться до",
    timeLeft: "Осталось",
    overdue: "Контрольное время прошло",
    overdueFor: "Просрочено на",
    daysShort: "д",
    history: "История выходов",
    call112: "Позвонить 112",
  },
  filters: {
    label: "Быстрые фильтры",
    short: "Полдня",
    day: "Целый день",
    multi: "Многодневные",
    easy: "Лёгкие T1–T2",
  },
  ui: {
    gradeAria: "Сложность T{n}",
  },
  common: {
    previous: "Назад",
    next: "Вперёд",
    close: "Закрыть",
    comingSoon: "Функционал в разработке",
    loading: "Загрузка…",
    dismissLabel: "Очистить",
  },

  news: {
    title: "Что нового",
    backToApp: "К приложению",
    backToArchive: "Все обновления",
    empty: "Пока нет обновлений",
    loadError: "Не удалось загрузить",
    showMore: "Показать ещё",
    notFoundTitle: "Документ не найден",
    notFoundBody: "Возможно, ссылка устарела.",
    accept: "Принять",
    accepted: "Принято",
    acceptError: "Не удалось принять, попробуйте ещё раз",
    loginToAccept: "Войдите, чтобы принять документ",
    outdated: "Это устаревшая версия документа.",
    openLatest: "Открыть актуальную версию",
  },
  notifications: {
    filterAll: "Все",
    filterUnread: "Непрочитанные",
    emptyUnread: "Непрочитанных уведомлений нет",
    unreadDot: "Есть непрочитанные уведомления",
    caption: "События по вашим маршрутам и новости сервиса",
    markAllRead: "Прочитать всё",
    showMore: "Показать ещё",
    emptyTitle: "Пока ничего нового",
    emptyBody: "Здесь появятся отзывы, напоминания о возвращении и новости EcoWay.",
    loading: "Загрузка...",
    accept: "Принять",
    unknown: "Уведомление",
    kinds: {
      review_received: { title: "Новый отзыв на маршрут", body: "«{route_name}»: {stars} из 5" },
      registration_soon: { title: "Скоро срок возвращения", body: "«{route_name}»: вернуться до {expected_return_at}" },
      registration_overdue: { title: "Срок возвращения прошёл", body: "«{route_name}»: ожидали до {expected_return_at}. Отметьте возвращение" },
      hello_published: { title: "Ваш привет опубликован" },
      feedback_new: { title: "Новое обращение в обратной связи" },
      hello_request_new: { title: "Новая заявка на привет", body: "От: {submitter_name}" },
      security_digest: { title: "События безопасности за час: {count}" },
      glitchtip_digest: { title: "Новые ошибки за час: {count}" },
    },
  },
  app: {
    skipToContent: "Перейти к содержимому",
    navLabel: "Основная навигация",
    profileButton: { guest: "Войти и открыть профиль", user: "Мой профиль" },
    tabs: { safety: "Безопасность", me: "Я", map: "Маршруты", live: "Live", explore: "Обзор", profile: "Профиль", admin: "Админка" },
    feedbackButton: "Отзыв",
    sidebar: { show: "Показать панель", hide: "Скрыть панель" },
    mapLoading: "Загрузка карты…",
    footer: { copyright: "© {year} EcoWay · оператор проекта: ТОО ORTRA · Казахстан" },
    install: {
      title: "Установить EcoWay",
      subtitle: "Быстрый доступ с главного экрана, как приложение",
      installButton: "Установить",
      dismissLabel: "Закрыть",
      iosInstructions: "Нажмите «Поделиться» внизу экрана Safari, затем «На экран «Домой»»",
    },
    cookieConsent: {
      title: "Мы используем cookie",
      message: "Технические cookie нужны для входа и просмотра видео с камер. С вашего согласия мы также используем аналитику, чтобы понимать, как улучшать EcoWay. Выбор можно изменить в любой момент в Профиль → Настройки.",
      acceptAll: "Принять все",
      essentialOnly: "Только необходимые",
      customize: "Настроить",
      customizeTitle: "Настройки cookie",
      alwaysOn: "Всегда включены",
      essential: {
        title: "Необходимые",
        description: "Вход в аккаунт, сессия просмотра видео с камер. Без них сайт не работает.",
      },
      analytics: {
        title: "Аналитика",
        description: "Google Analytics — помогает понять, какие разделы сайта востребованы.",
      },
      save: "Сохранить выбор",
      back: "Назад",
      dismissLabel: "Закрыть",
    },
  },

  leftPanel: {
    brand: "EcoWay",
    searchPlaceholder: "Поиск мест, маршрутов, точек",
    sortLabel: "Сортировка",
    sort: {
      recommended: "По актуальности",
      distance: "По расстоянию",
      elevation: "По набору",
      name: "По названию",
      nearest: "Ближе ко мне",
      duration: "По времени",
    },
  },

  routeStatus: {
    active: "Открыт",
    draft: "Умеренно",
    closed: "Закрыт",
    unknown: "—",
  },

  search: {
    cancel: "Отмена",
    recent: "Недавние запросы",
    showMore: "Смотреть ещё",
    clearHistory: "Очистить",
    groupPlaces: "Места",
    groupRoutes: "Маршруты",
    groupPoints: "Точки",
    more: "ещё {n}",
    noResults: "Ничего не найдено",
    loading: "Ищем…",
    originUser: "от вас",
    originCenter: "от центра",
    originToCenter: "Считать от центра карты",
    originToUser: "Считать от вашей позиции",
    nearTo: "рядом с {name} · {distance}",
    nearbyRoutes: "Маршруты рядом",
    example1: "Бутаковский водопад",
    example2: "Перевал Титова",
    example3: "Вода",
    example4: "Маршруты к озёрам",
    recentTitle: "Недавние",
    noResultsHint: "Попробуйте другое название или проверьте написание",
    error: "Не удалось выполнить поиск",
    retry: "Повторить",
    allRoutes: "Все маршруты",
    routeSubtitle: "Маршрут · {km} км",
    loadingRoutes: "Загружаем маршруты…",
    routesError: "Не удалось загрузить маршруты",
    elevation: "{m} м",
    kinds: { peak: "вершина", volcano: "вулкан", hill: "холм", ridge: "хребет", mountain_pass: "перевал", saddle: "седловина", spring: "родник", drinking_water: "питьевая вода", water_point: "источник воды", water_tap: "кран с водой", water_well: "колодец", waterfall: "водопад", shelter: "укрытие", alpine_hut: "приют", wilderness_hut: "хижина", camp_site: "кемпинг", mountain_rescue: "спасательный пост", rescue_hut: "спасательная хижина", viewpoint: "смотровая площадка", parking: "парковка", danger: "опасный участок", lake: "озеро", water: "водоём", glacier: "ледник", village: "село", town: "город", city: "город", hamlet: "посёлок", locality: "местность", firepit: "место для костра", picnic_table: "стол для пикника", toilets: "туалет", cave_entrance: "вход в пещеру", rock: "скала", tower: "вышка", cable_car_station: "станция канатной дороги", ford: "брод", grassland: "луг", wetland: "болото", suburb: "район", neighbourhood: "микрорайон", valley: "долина", gorge: "ущелье", region: "регион" },
  },

  point: {
    back: "Назад",
    close: "Закрыть карточку",
    loading: "Загружаем точку…",
    notFound: "Точка не найдена",
    notFoundHint: "Возможно, её скрыли или удалили. Вернитесь назад.",
    error: "Не удалось загрузить точку",
    nearbyPoints: "Точки рядом",
  },

  poiTypes: {
    start: "Старт",
    finish: "Финиш",
    "night-stop": "Ночёвка",
    "via-point": "Путевая точка",
    water: "Вода",
    danger: "Опасный участок",
    viewpoint: "Смотровая площадка",
    note: "Заметка",
    "rest-stop": "Стоянка/привал",
    junction: "Развилка",
    shelter: "Приют/укрытие",
    parking: "Парковка",
  },

  units: {
    km: "км",
    m: "м",
    decimal: ",",
    h: "ч",
    min: "мин",
    ms: "м/с",
    hpa: "гПа",
    mm: "мм",
    mmhr: "мм/ч",
    wm2: "Вт/м²",
  },

  reviews: {
    noRatings: "Пока без оценок",
    dialogTitle: "Ваш отзыв",
    yourRating: "Ваша оценка",
    commentLabel: "Комментарий (необязательно)",
    commentPlaceholder: "Как прошли, что с тропой, водой, погодой?",
    submit: "Отправить",
    delete: "Удалить отзыв",
    error: "Не удалось сохранить отзыв. Попробуйте ещё раз.",
    count: "Оценок: {n}",
    showMore: "Показать ещё",
    ctaTitle: "Прошли этот маршрут?",
    mineTitle: "Ваш отзыв",
    showAll: "Показать все отзывы ({n})",
    ctaText: "Поделитесь впечатлением: как тропа, вода, погода.",
    mineText: "Вы уже оценили этот маршрут.",
    cta: "Оставить отзыв",
    edit: "Изменить отзыв",
  },
  routeDetails: {
    actionsLabel: "Действия с маршрутом",
    conditionsNow: "Сейчас: {name}, {km} км",
    plate: { loss: "Спуск", distance: "Дистанция", gain: "Набор", max: "Высота", time: "Время" },
    back: "Назад",
    close: "Закрыть карточку",
    eyebrow: "Маршрут",
    description: "Описание",
    descriptionMore: "Читать дальше",
    descriptionLess: "Свернуть",
    weatherShort: "Погода",
    shareMenu: { link: "Поделиться ссылкой" },
    gettingThere: { title: "Как добраться до старта", copy: "Скопировать координаты", copied: "Координаты скопированы", open2gis: "Открыть в 2ГИС", openGoogleMaps: "Открыть в Google Картах" },
    maxElevation: "макс",
    stats: {
      distanceHint: "Расстояние маршрута",
      gainHint: "Набор высоты",
      lossHint: "Потеря высоты",
      maxElevationHint: "Максимальная высота на маршруте",
    },
    timeInTransit: "Время в пути — уточняется",
    estimatedTimeDisclaimer: "Расчётное время в пути, округлено до получаса в большую сторону (дистанция и уклон трека, формула Тоблера). Не учитывает физическую подготовку, вес рюкзака и погодные условия — фактическое время может заметно отличаться.",
    like: "Нравится",
    format: {
      label: "Формат",
      loop: "Кольцевой",
      linear: "Линейный",
      halfDay: "Полдня",
      fullDay: "Целый день",
      returnNote: "Возврат тем же путём",
    },
    actions: {
      registerFull: "Регистрация",
      save: "Сохранить",
      saved: "Сохранён",
      saveLoginRequired: "Войдите, чтобы сохранять маршруты",
      likeLoginRequired: "Войдите, чтобы поставить лайк",
      share: "Поделиться",
      register: "Регистр.",
      download: "Скачать",
    },
    elevationProfile: "Высотный профиль",
    elevationProfileAria: "Высотный профиль маршрута",
    elevationProfileCursorAria: "Высотный профиль маршрута — нажмите или потяните, чтобы поставить точку на маршруте",
    days: "Дни по маршруту",
    dayWord: { one: "день", few: "дня", many: "дней" },
    weather: {
      title: "Погода в районе маршрута",
      loading: "Загружаем прогноз…",
      windUpTo: "Ветер до",
      forecastSource: "Прогноз · open-meteo.com",
      unavailable: "Прогноз погоды для этого района недоступен",
      infoTitle: "Откуда эта погода?",
      infoText: "Погода усреднена по всему маршруту, а не привязана к конкретной точке. На длинных маршрутах условия на разных участках и высотах могут заметно отличаться от показанного прогноза.",
    },
    risks: {
      title: "Сезонные риски",
      text: "На теневых участках возможен лёд утром, после осадков — грязь и скользкие камни.",
    },
    feedbackCta: {
      text: "Заметили неточность или знаете, чем дополнить маршрут? Отправьте наблюдение — мы проверим информацию и добавим полезные изменения.",
      button: "Отправить наблюдение",
    },
    tabs: {
      label: "Разделы карточки",
      days: "Дни",
      overview: "Обзор",
      reviews: "Отзывы",
      photos: "Фото",
      soon: "скоро",
    },
    gpxModal: {
      disclaimer: "Маршрут и трек носят навигационный характер. На местности возможны погрешности — ориентируйтесь на фактические условия, разметку и обстановку.",
      downloadButton: "Скачать GPX",
    },
    selectRoute: "Выберите маршрут",
    toast: {
      saved: "Добавлено в сохранённые",
      linkCopied: "Ссылка скопирована",
    },
    grade: {
      1: "Легко",
      2: "Просто",
      3: "Средне",
      4: "Сложно",
      5: "Очень сложно",
      6: "Экстремально",
    },
    weatherCode: {
      "0": "Ясно",
      "1": "Малооблачно",
      "2": "Переменная облачность",
      "3": "Облачно",
      "45": "Туман",
      "48": "Изморозь",
      "51": "Мелкий дождь",
      "53": "Мелкий дождь",
      "55": "Сильная морось",
      "61": "Дождь",
      "63": "Дождь",
      "65": "Сильный дождь",
      "66": "Ледяной дождь",
      "67": "Ледяной дождь",
      "71": "Снег",
      "73": "Снег",
      "75": "Сильный снег",
      "77": "Снежная крупа",
      "80": "Ливень",
      "81": "Ливень",
      "82": "Сильный ливень",
      "85": "Снегопад",
      "86": "Сильный снегопад",
      "95": "Гроза",
      "96": "Гроза с градом",
      "99": "Гроза с градом",
    },
    advisory: {
      snow: "Возможен снег — на высоте держите тёплый слой и будьте готовы к скользким участкам.",
      rain: "Возможен дождь — тропа может быть скользкой, после осадков ожидайте грязь.",
      storm: "Риск грозы — избегайте открытых гребней и вершин.",
      fog: "Возможен туман — видимость на маршруте может быть ограничена.",
      none: "Существенных погодных рисков не ожидается.",
    },
    day: { today: "Сегодня", tomorrow: "Завтра" },
  },

  gradeModal: {
    title: "Что значит сложность?",
    close: "Закрыть",
    subtitle: "Шкала от T1 (просто) до T6 (экстрим)",
    thisRoute: "этот маршрут",
    footer: "Сложность T1–T6 описывает техническую сложность. Она не заменяет оценку погоды, сезона и вашей подготовки.",
    descriptions: {
      1: "Простая прогулка по хорошей тропе или дороге. Подходит для новичков и спокойных прогулок.",
      2: "Несложный горный маршрут по заметной тропе. Возможны подъёмы, камни или неровная поверхность.",
      3: "Требовательный горный маршрут. Нужна уверенная ходьба, нормальная физическая форма и внимание к погоде.",
      4: "Альпийский пеший маршрут. Возможны крутые участки, сыпуха, снег, плохая тропа и необходимость уверенного ориентирования.",
      5: "Сложный альпийский маршрут с трудным рельефом, экспозицией и участками без явной тропы. Требуется хороший опыт.",
      6: "Очень сложный альпийский пеший маршрут, часто без тропы, с выраженной экспозицией и трудным рельефом. Требуются отличные опыт, ориентирование и высокая подготовка.",
    },
  },

  login: {
    title: "Вход в EcoWay",
    subtitle: "Отслеживайте маршруты и получайте уведомления",
    email: "Email или телефон",
    password: "Пароль",
    passwordPlaceholder: "Введите пароль",
    confirmPassword: "Повторите пароль",
    passwordMismatch: "Пароли не совпадают",
    passwordHint: "Минимум 8 символов",
    showPassword: "Показать пароль",
    hidePassword: "Скрыть пароль",
    cancel: "Отмена",
    submitLoading: "Вход…",
    submit: "Войти",
    errorInvalid: "Неверный email/телефон или пароль",
    errorGeneric: "Не удалось войти. Попробуйте ещё раз позже.",
    orDivider: "или",
    emailToggle: "Войти по email",
    loginWithCode: "Войти по коду",
    loginWithPassword: "Войти по паролю",
    changeNumber: "Изменить номер",
    sendCode: "Отправить код",
    sendCodeLoading: "Отправка…",
    verifyCode: "Подтвердить",
    verifyCodeLoading: "Проверка…",
    otpCodeLabel: "Код из WhatsApp",
    otpInvalid: "Неверный или истёкший код",
    otpRateLimited: "Слишком много попыток. Попробуйте позже.",
    invalidPhone: "Введите корректный номер телефона",
    optionalEmailLabel: "Email (необязательно)",
    optionalEmailHint: "Сможете входить также по email с тем же паролем",
    phoneOtpStepTitle: "Введите код из WhatsApp",
    phoneOtpStepSubtitle: "Мы отправили код на {phone}",
    phonePasswordStepTitle: "Создайте пароль",
    phonePasswordStepSubtitle: "Телефон подтверждён — осталось задать пароль для входа",
    telegramWeb: "Войти через Telegram Web",
    telegramApp: "Войти через приложение Telegram",
    telegramWaiting: "Откройте Telegram и нажмите Start",
    telegramWaitingHint: "Страница обновится автоматически после подтверждения",
    telegramOpen: "Открыть Telegram",
    telegramRetry: "Попробовать снова",
    telegramLinkConflict: "Этот Telegram уже привязан к другому аккаунту",
    telegramGenericError: "Не удалось войти через Telegram. Попробуйте ещё раз.",
    google: "Войти через Google",
    telegramOidc: "Войти через Telegram",
    oauthGenericError: "Не удалось войти. Попробуйте ещё раз или другим способом.",
    registerToggle: "Нет аккаунта? Зарегистрироваться",
    loginToggle: "Уже есть аккаунт? Войти",
    forgotPassword: "Забыли пароль?",
    registerTitle: "Регистрация",
    registerSubmit: "Зарегистрироваться",
    registerSubmitLoading: "Регистрация…",
    registerSuccessTitle: "Проверьте почту",
    registerSuccessBody: "Мы отправили письмо со ссылкой для подтверждения на {email}",
    registerErrorGeneric: "Не удалось зарегистрироваться. Попробуйте ещё раз позже.",
    emailNotVerifiedError: "Почта не подтверждена — мы отправили письмо ещё раз",
    forgotTitle: "Восстановление пароля",
    forgotSubtitle: "Введите email — пришлём ссылку для сброса пароля",
    forgotSubmit: "Отправить ссылку",
    forgotSubmitLoading: "Отправка…",
    forgotSuccessBody: "Если у {email} есть аккаунт с паролем, письмо уже отправлено",
    backToLogin: "Назад ко входу",
  },

  conflict: {
    title: "Это вы?",
    subtitle: "Такой способ входа уже привязан к этому профилю. Войдите, чтобы подтвердить, что это вы, и привязать новый способ.",
    loginWithPassword: "Войти по email/телефону и паролю",
    cancel: "Отмена",
    success: "Готово! Способ входа привязан.",
    error: "Не удалось привязать. Попробуйте ещё раз.",
  },

  oauthCallback: {
    processing: "Входим…",
    linkedTitle: "Готово",
    linkedBody: "Способ входа привязан к вашему профилю",
    errorTitle: "Не удалось войти",
    errorBody: "Попробуйте ещё раз или воспользуйтесь другим способом входа",
    browserMismatch: "Вход был начат в другом браузере. Начните вход заново на этом устройстве.",
    identityAlreadyLinked: "Этот аккаунт уже привязан к другому профилю EcoWay. Войдите через него или отвяжите его там.",
    providerAlreadyLinked: "Способ входа этого типа уже привязан к вашему профилю",
    backToMap: "На карту",
    backToProfile: "В профиль",
  },

  emailVerify: {
    processing: "Подтверждаем почту…",
    successTitle: "Почта подтверждена",
    successBody: "Теперь войдите по почте и паролю.",
    errorTitle: "Ссылка недействительна",
    errorBody: "Ссылка устарела или уже была использована. Запросите подтверждение заново.",
    backToMap: "На карту",
  },

  resetPassword: {
    title: "Новый пароль",
    passwordLabel: "Новый пароль",
    submit: "Сохранить пароль",
    submitLoading: "Сохраняем…",
    successTitle: "Пароль обновлён",
    successBody: "Теперь можно войти с новым паролем",
    errorTitle: "Ссылка недействительна",
    errorBody: "Ссылка устарела или уже была использована. Запросите сброс пароля заново.",
    login: "Войти",
  },

  hlsPlayer: {
    unavailable: "Поток недоступен",
    stillWatching: "Вы ещё смотрите?",
    continue: "Продолжить",
  },

  videoControls: {
    play: "Воспроизвести",
    pause: "Пауза",
    mute: "Выключить звук",
    unmute: "Включить звук",
    fullscreen: "На весь экран",
    seek: "Перемотка",
  },

  live: {
    cameraAlt: "Снимок с камеры «{name}»",
    playCamera: "Смотреть трансляцию",
    title: "Live",
    nowTitle: "Сейчас",
    nodesCount: "точек",
    eventsCount: "событий",
    lastReading: "Последние показания:",
    refresh: "Обновить",
    noNodes: "Нет доступных точек",
    noEvents: "Пока нет опубликованных событий",
    liveBadge: "LIVE",
    privateCamera: "Приватная камера",
    close: "Закрыть",
    edited: "ред.",
    edit: "Редактировать",
    delete: "Удалить",
    postMenu: "Меню поста",
    like: "Нравится",
    composerPlaceholder: "Что нового?",
    composerPublish: "Опубликовать",
    composerSave: "Сохранить",
    composerCancel: "Отмена",
    addPhoto: "Добавить фото",
    removePhoto: "Удалить фото",
    editPostTitle: "Редактирование поста",
    deleteConfirm: "Удалить этот пост?",
    postFailed: "Не удалось сохранить пост",
    pin: "Закрепить",
    unpin: "Открепить",
    pinned: "Закреплено",
    pinFailed: "Не удалось изменить закрепление",
    pinLimitReached: "Можно закрепить не более 2 элементов",
    attachVideo: "Прикрепить видео",
    removeVideo: "Убрать видео",
    selectVideoTitle: "Выбор видео из хранилища",
    noAvailableVideos: "Нет доступных видео",
    sunrise: "Восход",
    sunset: "Закат",
    sunAt: "{label} в {time}",
    infoTooltip: {
      label: "Подробнее",
      rainPossible: "Предположение сделано на основе показаний метеостанции на шатре (влажность и точка росы) — осадки не гарантированы, но вероятны.",
      windy: "Устойчивый ветер от 8 м/с — уже заметно на маршруте, особенно на открытых участках.",
      windStrong: "Устойчивый ветер от 15 м/с — порог опасного явления по критериям гидрометеослужбы. На открытых гребнях и вершинах будьте особенно осторожны.",
      windGusty: "Порывы заметно сильнее среднего ветра — возможны резкие рывки, особенно на открытых и возвышенных участках.",
      sunrise: "Время рассчитано с учётом окружающего рельефа и отражает момент, когда солнце фактически появится над линией горизонта. Светать на местности может начать раньше этого времени.",
      sunset: "Время рассчитано с учётом окружающего рельефа и отражает момент, когда солнце фактически скроется за линией горизонта. Темнеть может начать позже этого времени.",
      uvLevels: {
        low: "Низкий риск для большинства людей — специальная защита не нужна, в яркий день можно надеть солнцезащитные очки.",
        moderate: "Умеренный риск — в полуденные часы желательно находиться в тени, использовать крем SPF 30+, головной убор и очки.",
        high: "Высокий риск солнечного ожога — обязательны крем SPF 30+, головной убор и очки, старайтесь избегать прямого солнца с 11:00 до 16:00.",
        veryHigh: "Очень высокий риск — кожа может обгореть за 15–25 минут. Крем SPF 50, максимально закрывайте кожу, ищите тень в течение дня.",
        extreme: "Экстремальный риск — незащищённая кожа может обгореть за несколько минут. По возможности избегайте солнца, используйте плотную одежду и крем SPF 50+.",
      },
    },
    stationDetail: {
      temp: "Темп",
      feelsLike: "Ощущается",
      wind: "Ветер",
      windGust: "Порывы",
      humidity: "Влажн.",
      dewPoint: "Точка росы",
      pressure: "Давление",
      rainRate: "Осадки",
      rainTotal: "Осадки за сутки",
      solar: "Солнце",
      uv: "УФ-индекс",
      nearbyPlaceholder: "Ближайшие маршруты загружаются из API",
      compass: { n: "С", ne: "СВ", e: "В", se: "ЮВ", s: "Ю", sw: "ЮЗ", w: "З", nw: "СЗ" },
      uvLevels: {
        low: "Низкий",
        moderate: "Умеренный",
        high: "Высокий",
        veryHigh: "Очень высокий",
        extreme: "Экстремальный",
      },
      alerts: {
        raining: "Идёт дождь",
        rainPossible: "Возможны осадки",
        windy: "Ветрено",
        windStrong: "Сильный ветер",
        windGusty: "Порывистый ветер",
        feelsLike: "{actual}° (ощущается как {feels}°)",
      },
      descriptions: {
        temp: "Температура воздуха на станции.",
        feelsLike: "Ощущаемая температура с учётом охлаждения ветром (холод) или влажности (жара).",
        humidity: "Относительная влажность воздуха.",
        dewPoint: "Температура, при которой воздух насыщается влагой.",
        wind: "Скорость и направление ветра сейчас.",
        windGust: "Максимальный порыв ветра за последний интервал.",
        pressure: "Атмосферное давление.",
        rainRate: "Интенсивность осадков прямо сейчас.",
        rainTotal: "Сумма осадков за сутки.",
        solar: "Интенсивность солнечного излучения.",
        uv: "Риск получить солнечный ожог кожи.",
      },
    },
    detailsTitle: "Все показатели",
  },

  liveHome: {
    subtitle: "Что происходит у геошатра прямо сейчас: камеры, метеостанция, таймлапсы и приветы.",
    title: "Live",
    close: "Закрыть",
    aboutBanner: {
      text: "Проект EcoWay развивается при участии Visit Almaty, Иле-Алатауского природного парка и ДЧС г. Алматы",
      button: "О проекте",
    },
    timelapseFeed: {
      title: "Таймлапсы",
      descriptionPlaceholder: "Короткое описание (необязательно)",
      deleteConfirm: "Удалить этот таймлапс из карусели?",
      pin: "Закрепить",
      unpin: "Открепить",
      pinLimitReached: "Можно закрепить не более 2 таймлапсов на точку",
      pinFailed: "Не удалось изменить закрепление",
      download: "Скачать",
      editDescription: "Изменить описание",
      saveDescription: "Сохранить",
      saveFailed: "Не удалось сохранить изменения",
      itemMenu: "Меню",
      delete: "Удалить",
    },
  },

  helloFeed: {
    title: "#ПриветEcoway",
    postCount: "всего {count} приветов с Мынжылкы",
    uploadButton: "Добавить публикацию",
    play: "Воспроизвести",
    remove: "Убрать",
    captionPlaceholder: "Подпись (необязательно)",
    publish: "Опубликовать",
    download: "Скачать",
    deleteConfirm: "Удалить эту публикацию?",
    empty: "Пока нет публикаций",
    uploadFailed: "Не удалось загрузить файл",
    itemMenu: "Меню",
    editCaption: "Изменить подпись",
    saveCaption: "Сохранить",
    delete: "Удалить",
    saveFailed: "Не удалось сохранить изменения",
    wave: {
      openButton: "Следующий твой",
      title: "Отправляй свой видео привет",
      intro: "Маши, танцуй, удивляй 🙂 Чуть позже твоя видеооткрытка появится в ленте #ПриветEcoway. Скачивай и отправляй друзьям",
      dateLabel: "Дата",
      timeLabel: "Время",
      consent: "Я согласен(на) на обработку и публикацию видео с моим участием в #ПриветEcoway",
      consentLink: "Согласие на видеопривет",
      submit: "Отправить",
      cancel: "Отмена",
      successTitle: "Твой привет принят 👋.",
      successMessage: "Следи за лентой #ПриветEcoway — видеооткрытка появится там сегодня",
      close: "Закрыть",
      errorRequired: "Укажи дату и время",
      errorConsent: "Нужно согласие на публикацию",
      errorFuture: "Это время ещё не наступило",
      errorTooOld: "Приветы отсматриваем в течение двух недель",
      errorGeneric: "Не удалось отправить заявку. Попробуй ещё раз позже.",
    },
  },

  explore: {
    noRoutes: "Нет маршрутов",
    onMap: "На карте",
    comingSoon: {
      title: "Скоро здесь появится умный подбор маршрутов.",
      body: "Расскажите, куда и зачем хотите отправиться, — EcoWay поможет подобрать подходящие места и маршруты под ваши цели, возможности и настроение.",
    },
  },

  feedback: {
    form: {
      title: "Обратная связь",
      message: "Сообщение",
      messagePlaceholder: "Опишите, что случилось или что можно улучшить",
      images: "Фото",
      addImage: "Добавить фото",
      removeImage: "Удалить фото",
      imagesHint: "До {max} фото, не более {mb} МБ каждое",
      tooManyImages: "Можно приложить не более {max} фото",
      imageTooLarge: "Файл «{name}» больше {mb} МБ",
      contactName: "Имя",
      contactNamePlaceholder: "Необязательно",
      contactPhone: "Телефон",
      contactEmail: "Email",
      messengerConsent: "Я согласен, чтобы со мной связались через {provider}",
      submit: "Отправить",
      errorGeneric: "Не удалось отправить сообщение. Попробуйте ещё раз.",
    },
    success: {
      title: "Спасибо!",
      message: "Ваше сообщение получено, мы обязательно его рассмотрим.",
    },
  },

  profile: {
    markers: { emptyTitle: "Пока нет меток", empty: "Поставьте точку на карте инструментом «Метка» и сохраните её как свою.", onMap: "На карте", show: "Показать на карте", hide: "Скрыть с карты" },
    title: "Профиль",
    loginPrompt: "Войдите в аккаунт",
    loginSubtitle: "Отслеживайте маршруты и получайте уведомления",
    loginButton: "Войти",
    editButton: "Редактировать профиль",
    sections: {
      notifications: "Уведомления",
      saved: "Сохранённые",
      markers: "Мои метки",
      trail: "Мой путь",
      collection: "Мои маршруты",
      safety: "Безопасность",
      settings: "Настройки",
    },
    trail: {
      caption: "Личный прогресс по горам Алматы",
      distance: "пройдено",
      gain: "набор",
      routesCount: "маршрутов",
      locationsCount: "локаций",
      highestPoint: "высшая точка",
      lastRouteTileEarned: "последний",
      lastRouteTileEmpty: "пусто",
      lastRouteCardLabel: "Последний маршрут",
      emptyNote: "Сохраните маршрут и пройдите его — здесь появится статистика",
    },
    collection: {
      caption: "Ваши маршруты и сохранённые из каталога",
      tabs: { mine: "Мои", saved: "Сохранённые" },
      mineEmptyNote: "Нарисуйте свой первый маршрут в редакторе на карте, и он появится здесь",
      card: {
        public: "Публичный маршрут, виден всем",
        private: "Приватный маршрут, виден только вам",
        makePublic: "Сделать публичным",
        makePrivate: "Сделать приватным",
        views: "Просмотры",
        likes: "Лайки",
        saves: "Сохранения",
        share: "Поделиться",
        edit: "Править",
      shareDisabled: "Сделайте маршрут публичным, чтобы поделиться",
      delete: "Удалить маршрут",
      deleteConfirmTitle: "Удалить маршрут «{name}»?",
      deleteConfirmBody: "Маршрут и его отзывы будут удалены без возможности восстановления.",
      deleted: "Маршрут удалён",
      deleteError: "Не удалось удалить маршрут",
      deleteCancel: "Отмена",
        nowPublic: "Маршрут стал публичным",
        nowPrivate: "Маршрут стал приватным",
        visibilityError: "Не удалось изменить приватность",
        linkCopied: "Ссылка скопирована",
      },
      completedEmptyNote: "Пройденные маршруты появятся здесь после завершения похода",
      savedEmptyNote: "Сохранённые маршруты появятся здесь",
    },
    safety: {
      caption: "Регистрируйте свои выходы и делитесь планом маршрута с близкими — это простая базовая мера безопасности перед походом.",
      activeTripLabel: "Активный / ближайший поход",
      noActiveTrip: "Нет зарегистрированных походов",
      noActiveTripHint: "Зарегистрируйте маршрут перед выходом",
      emergencyContact: "Экстренный контакт",
      emergencyNotSet: "Не задан",
      emergencyContactHint: "Подставляется по умолчанию при регистрации на маршрут — там его можно изменить для конкретного выхода.",
      emergencyAddButton: "Добавить",
      emergencyDeleteButton: "Удалить",
      emergencyContactSave: "Сохранить",
      emergencyContactCancel: "Отмена",
      emergencyContactSaved: "Экстренный контакт сохранён",
      emergencyContactSaveError: "Не удалось сохранить экстренный контакт",
      emergencyContactDeleted: "Экстренный контакт удалён",
      emergencyContactDeleteError: "Не удалось удалить экстренный контакт",
      emergencyDeleteConfirmTitle: "Удалить экстренный контакт?",
      emergencyDeleteConfirmMessage: "Он больше не будет подставляться по умолчанию при регистрации на маршрут.",
      guideTitle: "Что делать, если…",
      guide: {
        lostTrail: { title: "Потерял тропу", body: "Остановитесь, оцените видимость, вернитесь по своим следам до последней уверенной точки. Не идите дальше в туман." },
        badWeather: { title: "Погода ухудшилась", body: "Спускайтесь немедленно, держитесь долин, избегайте гребней и металлических объектов в грозу." },
        noSignal: { title: "Нет сигнала", body: "Поднимитесь выше или к открытому месту. Попробуйте SMS — оно проходит при слабом сигнале. Сохраняйте батарею." },
        deadPhone: { title: "Сел телефон", body: "Авиарежим, минимум яркости, отключите GPS до необходимости. Сообщите координаты заранее экстренному контакту." },
        needHelp: { title: "Нужна помощь", body: "Звоните 112. Сообщите координаты, состояние, число людей. Останьтесь на месте, если безопасно." },
      },
    },
    settings: {
      admin: "Админ-панель",
      caption: "Язык и аккаунт",
      language: "Язык",
      privacy: "Приватность",
      privacyOnlyMe: "Только я",
      privacyPublic: "Публичный",
      help: "Помощь",
      cookies: "Настройки cookie",
      feedback: "Обратная связь",
      logout: "Выйти",
      linkedAccounts: "Связанные аккаунты",
      methodEmail: "Email",
      methodPhone: "Телефон",
      methodTelegram: "Telegram",
      methodGoogle: "Google",
      methodVerified: "подтверждено",
      methodUnverified: "не подтверждено",
      addGoogle: "Привязать Google",
      addTelegram: "Привязать Telegram",
      linkGenericError: "Не удалось привязать. Попробуйте ещё раз.",
      unlink: "Отвязать",
      unlinkLastMethodError: "Нельзя отвязать последний способ входа в аккаунт",
    },
    language: "Язык",
    about: "О проекте",
  },

  editProfile: {
    onboardingTitle: "Заполните профиль",
    onboardingSubtitle: "Это займёт минуту — часть полей можно оставить пустыми",
    editTitle: "Редактировать профиль",
    avatarChange: "Изменить аватар",
    avatarRemove: "Удалить аватар",
    avatarError: "Не удалось обновить аватар",
    avatarLoadingFromProvider: "Загружаем аватар из Telegram…",
    cropTitle: "Обрезка аватара",
    cropApply: "Применить",
    cropHint: "Перетащите рамку или потяните за уголок, чтобы изменить размер",
    username: "Никнейм",
    usernameRequired: "Никнейм обязателен",
    usernameFormat: "3–30 символов: строчные латинские буквы, цифры, _",
    usernameReserved: "Этот никнейм зарезервирован",
    usernameTaken: "Этот никнейм уже занят",
    firstName: "Имя",
    lastName: "Фамилия",
    gender: "Пол",
    genderUnset: "Не указан",
    genderMale: "Мужской",
    genderFemale: "Женский",
    genderOther: "Другой",
    birthDate: "Дата рождения",
    visibility: "Публичный профиль",
    visibilityHint: "Определяет, что видят посторонние по вашей ссылке",
    visibilityPrivate: "Приватный",
    visibilityPublic: "Публичный",
    submitOnboarding: "Продолжить",
    submitEdit: "Сохранить",
    saveError: "Не удалось сохранить профиль",
    consentText: "Я принимаю Пользовательское соглашение и даю согласие на сбор и обработку персональных данных в соответствии с Политикой конфиденциальности.",
  },

  publicProfile: {
    routesTitle: "Маршруты автора",
    routesEmpty: "Пока нет публичных маршрутов",
    notFoundTitle: "Профиль не найден",
    notFoundSubtitle: "Такого пользователя нет, либо ссылка устарела",
    private: "Профиль закрыт",
  },

  hikeCard: {
    notFoundTitle: "Выход не найден",
    notFoundSubtitle: "Такой регистрации нет, либо ссылка устарела",
    dates: "Даты",
    participants: "Участники",
    track: "Трек",
    emergencyContact: "Экстренный контакт",
    footnote: "Информация о выходе передана в рамках пилотного проекта EcoWay и ДЧС города Алматы. Официальной регистрацией в МЧС это не является.",
    openOnMap: "Открыть маршрут на карте",
    status: {
      active: "В процессе",
      returned: "Завершён",
      cancelled: "Отменён",
    },
  },

  routeRegistration: {
    banner: {
      soon: "Ваша регистрация скоро истекает: осталось {minutes} мин",
      overdue: "Срок возвращения прошёл",
      extend: "Продлить на час",
      returned: "Я вернулся",
      hide: "Скрыть",
      error: "Что-то пошло не так. Попробуйте ещё раз.",
    },
    profile: {
      extendButton: "+1 ч",
      title: "Регистрация на маршрут",
      registerButton: "Регистрация на маршрут",
      expectedReturn: "Контрольное время",
      cancelButton: "Отменить",
      returnButton: "Я вернулся",
      cancelConfirmTitle: "Отменить выход?",
      cancelConfirmMessage: "Регистрация будет отменена. Это действие нельзя отменить.",
      cancelConfirmButton: "Да, отменить",
      returnConfirmTitle: "Отметиться о возвращении?",
      returnConfirmMessage: "Регистрация будет закрыта как завершённая.",
      returnConfirmButton: "Да, я вернулся",
      keepButton: "Не сейчас",
      editButton: "Изменить",
      shareButton: "Поделиться",
      changesSaved: "Изменения сохранены",
      shareText: "Я ушел в поход и зарегистрировал его в ДЧС.",
      shareCopied: "Ссылка скопирована",
      shareCopyError: "Не удалось скопировать ссылку",
    },
    form: {
      title: "Регистрация на маршрут",
      whyRegister: "Регистрируйте свои выходы — это простая базовая мера безопасности перед походом.",
      editTitle: "Изменить регистрацию",
      saveChanges: "Сохранить",
      steps: { route: "Маршрут", dates: "Даты", contacts: "Контакты", confirm: "Подтверждение" },
      stepCounter: "Шаг {n} из {total}",
      changeRoute: "Изменить",
      back: "Назад",
      cancel: "Отмена",
      next: "Далее",
      contactPhone: "Мой телефон",
      emergencyContactPhone: "Экстренный контакт — телефон",
      emergencyContactHint: "Номер человека, остающегося на связи в городе",
      invalidPhone: "Введите номер в формате +7XXXXXXXXXX",
      route: "Маршрут",
      routeListLabel: "Список маршрутов",
      routeTabSaved: "Избранные",
      routeTabMine: "Мои",
      routeTabAll: "Все",
      noSavedRoutes: "В избранном пока ничего нет. Сохраните маршрут в каталоге или найдите его через поиск.",
      noOwnRoutes: "У вас пока нет своих маршрутов.",
      routeModeDirectory: "Из справочника",
      routeModeManual: "Описать вручную",
      routeModeTrack: "Свой трек",
      noRoutesFound: "Маршруты не найдены",
      routeDescriptionPlaceholder: "Опишите маршрут своими словами",
      trackUploadPrompt: "Загрузить файл GPX",
      trackExistingFile: "Загруженный трек",
      trackApproxDistance: "≈ {km} км по треку",
      trackInvalidFile: "Нужен файл в формате .gpx",
      trackTooLarge: "Файл больше {mb} МБ",
      trackParseError: "Не удалось прочитать трек — проверьте файл",
      participants: "Участники",
      participantsPlaceholder: "Перечислите участников похода",
      startDate: "Дата старта",
      expectedReturn: "Контрольное время возвращения",
      quickHint: "Время возврата заполнено по расчётному времени маршрута с запасом. Проверьте и подтвердите.",
      editDetails: "Изменить детали",
      consentCombined: "Я принимаю условия регистрации маршрута и даю согласие на обработку и передачу указанных данных в ДЧС города Алматы.",
      consentServiceRulesLink: "Правила сервиса «Безопасность»",
      consentDchsDataLink: "Согласие на обработку и передачу данных",
      submit: "Зарегистрироваться",
      errorAlreadyActive: "У вас уже есть активная регистрация — сначала завершите её.",
      errorGeneric: "Не удалось отправить регистрацию. Попробуйте ещё раз.",
    },
    terms: {
      close: "Понятно",
    },
    success: {
      title: "Маршрут зарегистрирован",
      message: "Информация о вашем маршруте сохранена в EcoWay и в рамках пилота доступна ДЧС. Поделитесь планом с близкими, чтобы они знали, куда вы отправились и когда планируете вернуться.",
    },
  },

  aboutProject: {
    backButton: "Назад",
    navTitle: "О проекте",
    hero: { tagline: "Живая карта природных маршрутов" },
    section1: {
      title: "Карта, которую мы строим вместе",
      body1: "Ни одна карта не может оставаться актуальной сама по себе. Тропы меняются. Вода появляется и исчезает. Броды становятся сложнее. Где-то размывает участок, где-то появляется удобное место для остановки.",
      body2: "Поэтому EcoWay развивается вместе с теми, кто ходит по этим маршрутам. Заметили что-то важное — добавьте наблюдение. Вода, состояние тропы, брод, кемпинг, мусор или другое изменение — каждая отметка делает общую карту полезнее для тех, кто пойдёт следом.",
      cta: "Добавить наблюдение",
    },
    section2: {
      title: "Видеть больше до выхода",
      body1: "Часть информации EcoWay приходит непосредственно с территории. Live-камеры помогают увидеть реальную обстановку, а данные с точек — понять погоду и условия на месте.",
      body2: "Мы хотим, чтобы перед выходом можно было не только посмотреть прогноз или описание маршрута, а увидеть, что происходит там на самом деле.",
      cta: "Смотреть Live",
    },
    section3: {
      title: "Оставьте информацию о своём пути",
      body1: "Безопасность начинается с простых привычек. Регистрируйте свои выходы и делитесь планом маршрута с близкими — чтобы информация о том, куда вы отправились и когда планируете вернуться, оставалась доступной.",
      body2: "Сервис регистрации маршрутов EcoWay развивается в пилотном режиме совместно с ДЧС г. Алматы.",
      cta: "Безопасность",
    },
    section4: {
      title: "EcoWay только начинается",
      body1: "Мы постепенно добавляем новые маршруты, точки наблюдения и данные с природных территорий.",
      body2: "Наша цель — чтобы со временем EcoWay стал местом, где перед выходом можно выбрать маршрут, понять реальную обстановку, подготовиться к условиям и оставить информацию о своём пути.",
      body3: "Чем больше людей делятся тем, что видят на маршрутах, тем точнее становится эта картина.",
      closing: "Строим живую карту вместе.",
    },
    sponsors: {
      title: "При поддержке и участии",
      park: "Иле-Алатауский природный парк",
      mes: "ДЧС г. Алматы",
    },
    cta: {
      title: "Есть что добавить?",
      body: "Нашли неточность, знаете маршрут, хотите предложить новую точку или идею для EcoWay — расскажите нам.",
      button: "Написать нам",
    },
    brandLine: "Будь уверен в своём пути",
    contactsTitle: "Контакты",
    documents: {
      title: "Документы",
      privacyPolicy: "Политика конфиденциальности",
      termsOfService: "Пользовательское соглашение",
      dataConsent: "Согласие на сбор и обработку данных",
      serviceRules: "Правила сервиса «Безопасность»",
      routeDataConsent: "Согласие на передачу данных ДЧС г. Алматы",
      videoGreetingConsent: "Согласие на формирование и публикацию видеопривета EcoWay (тестовый период)",
    },
  },

  legalDocuments: {
    languageLabel: "Язык документа",
  },

  camera: {
    live: "LIVE",
    watchStream: "Смотреть трансляцию →",
  },

  map: {
    tools: { button: "Инструменты" },
    contextLost: {
      message: "Карта временно недоступна на этом устройстве.",
      retry: "Обновить",
    },
    layers: {
      base: "Базовая карта",
      nodes: "Точки (камеры и станции)",
      routes: "Маршруты",
      pois: "Точки маршрутов",
    },
    locateMe: "Моё местоположение",
    locateMeApproximate: "Моё местоположение (приблизительно, по IP)",
    northUp: "Повернуть на север",
    compassMode: "Карта по компасу",
    toggle3d: "Включить рельеф (3D)",
    toggle2d: "Выключить рельеф (2D)",
    layersControl: {
      button: "Слои карты",
      base: "Карта",
      topo: "Топо",
      topo3d: "3D топо",
      poi: "Слои значков",
      poiGroup: {
        stayWater: "Ночлег и вода",
        obstacles: "Препятствия",
        rest: "Отдых",
        viewpoint: "Смотровые",
        amenities: "Удобства",
      },
      poiGroupInfo: {
        stayWater: "Кемпинги, горные и жилые хижины, родники, колодцы, водоразборы, питьевая вода, водопады.",
        obstacles: "Броды через реки и ручьи.",
        rest: "Навесы, кострища, столы для пикника.",
        viewpoint: "Смотровые площадки.",
        amenities: "Туалеты, мусорные баки и контейнеры.",
      },
      overlays: "Тематические слои",
      style: "Стиль карты",
      styleDefault: "Наш",
      styleGenshtab: "Генштаб",
      protectedAreas: "Нацпарки и заповедники",
      routeCoverage: "Покрытие троп маршрутами",
      coveragePopupTitle: "Маршруты здесь",
      coverageOpen: "Открыть",
    },
    attribution: {
      title: "Данные карты",
      button: "Об источниках данных карты",
      close: "Закрыть",
      licence: "Картографические данные OpenStreetMap доступны по лицензии ODbL.",
    },
    pointTool: {
      button: "Метка на карте",
      title: "Точка",
      close: "Закрыть",
      copy: "Скопировать координаты",
      copied: "Скопировано",
      ownMarker: "Своя метка",
      rename: "Переименовать",
      routesHere: "Маршруты сюда",
      startHere: "Старт отсюда",
      share: "Поделиться",
      delete: "Удалить",
      loginRequired: "Войдите, чтобы сохранять метки",
      namePlaceholder: "Название метки",
      kindLabel: "Тип метки",
      saveMarker: "Сохранить",
      cancel: "Отмена",
      draftExists: "В редакторе уже есть черновик - очистите его, чтобы начать отсюда",
      failed: "Не удалось сохранить метку",
      kind: {
        custom: "Своя",
        camp: "Стоянка",
        water: "Вода",
        viewpoint: "Смотровая",
        danger: "Опасность",
        parking: "Парковка",
        other: "Другое",
      },
    },
    editMode: "Ред. карты",
    debugPanel: "Отладка карты",
    editSaved: "Изменения сохранены",
    editReverted: "Правка удалена, объект вернулся к исходным данным",
    editSaveError: "Не удалось сохранить изменения",
    ruler: {
      button: "Линейка",
      title: "Линейка",
      close: "Закрыть линейку",
      hint: "Кликните по карте, чтобы поставить точки. Правый клик или долгое нажатие по линии — добавить или убрать точку.",
      details: "Характеристики линии",
      total: "Всего",
      gain: "Набор",
      loss: "Потеря",
      noElevation: "Высота недоступна вне района покрытия рельефа.",
      partialElevation: "Часть линии вне покрытия рельефа — итог по измеримым участкам.",
      clear: "Очистить",
      vertexAria: "Точка линейки",
      menuAddPoint: "Добавить точку здесь",
      menuDeletePoint: "Удалить эту точку",
      menuStraightenLeg: "Спрямить отрезок",
      menuMagnetizeLeg: "Примагнитить отрезок",
      magnet: "Магнит: строить путь по дорогам и тропам",
      undo: "Отменить последнее действие",
      redo: "Повторить отменённое действие",
      routingFallback: "Маршрут по сети не найден — проведена прямая линия.",
      routeBlocked: "Не можем проложить сюда: на пути река или обрыв — точка не добавлена.",
    },
    routeEditor: {
      button: "Редактор маршрута",
      title: "Редактор маршрута",
      close: "Закрыть редактор",
      authRequired: "Войдите, чтобы рисовать и сохранять свои маршруты.",
      modeLine: "Линия",
      modeWaypoint: "Точки",
      hintLine: "Кликните по карте, чтобы нарисовать маршрут.",
      hintWaypoint: "Кликните по карте, чтобы поставить точку выбранного типа.",
      magnet: "Магнит: строить путь по дорогам и тропам",
      magnetShort: "Магнит",
      snapWaypointToLine: "Примагничивать точку к линии маршрута",
      undo: "Отменить последнее действие",
      redo: "Повторить отменённое действие",
      clear: "Очистить всё",
      total: "Всего",
      gain: "Набор",
      loss: "Потеря",
      duration: "Время в пути",
      noElevation: "Высота недоступна вне района покрытия рельефа.",
      segments: "Дни и сегменты",
      waypointType: "Тип точки",
      waypointName: "Название",
      waypointDescription: "Описание",
      deleteWaypoint: "Удалить точку",
      deleteLastPoint: "Удалить последнюю точку линии",
      openMine: "Мои маршруты",
      newRoute: "Новый маршрут",
      save: "Сохранить",
      saveAs: "Сохранить как…",
      exportGpx: "Экспорт в GPX",
      cancelConfirm: "Отменить редактирование? Несохранённые изменения будут потеряны.",
      unsavedTitle: "Выйти из редактора?",
      routeBlocked: "Не можем проложить маршрут сюда: на пути река или обрыв",
      labelUndo: "Отменить",
      labelRedo: "Повторить",
      labelReverse: "Развернуть",
      labelCloseLoop: "Замкнуть",
      labelLegStraight: "Прямая",
      labelLegRouted: "По тропам",
      labelSnapPoint: "К линии",
      labelInfo: "Подсказки",
      closeShort: "Закрыть",
      actionsLabel: "Действия с маршрутом",
      toolsLabel: "Инструменты редактора",
      downloadGpx: "Скачать GPX",
      importLabel: "Импорт",
      importFromGpx: "Из GPX",
      importFromCatalogue: "Из каталога",
      importFromMine: "Из моих",
      labelNew: "Новый",
      hintNew: "Новый маршрут",
      hintUndo: "Отменить последнее действие",
      hintRedo: "Повторить отменённое действие",
      hintReverse: "Развернуть маршрут: старт и финиш меняются местами",
      hintCloseLoop: "Замкнуть маршрут: проложить участок от финиша к старту",
      hintLegStraight: "Участок {km} км: прямой. Нажмите, чтобы проложить по тропам",
      hintLegRouted: "Участок {km} км: по тропам. Нажмите, чтобы сделать прямым",
      hintSnapPoint: "Притянуть выбранную точку к линии или тропе",
      hintInfo: "Подсказки: что делает каждая кнопка",
      onboardingTitle: "Редактор маршрутов",
      onboardingIntro: "Короткая памятка. Подсказки по кнопкам всегда доступны в нижней панели: «Действия» → «Подсказки».",
      dontShowAgain: "Больше не показывать",
      gotIt: "Понятно",
      onboarding: {
        line: { title: "Линия", text: "Нажмите кнопку и тапайте по карте, чтобы рисовать маршрут." },
        point: { title: "Точка", text: "Ночёвка делит маршрут на дни, привал делит день на участки." },
        erase: { title: "Ластик", text: "Тап по вершине линии или по точке удаляет её." },
        magnet: { title: "Магнит", text: "Участки линии прокладываются по тропам и дорогам, а точки притягиваются к линии и тропам." },
        edit: { title: "Правка", text: "Перетаскивайте вершины и точки, тапайте по точке, чтобы изменить её, или по линии, чтобы выбрать участок." },
      },
      toolLine: "Линия",
      toolPoint: "Точка",
      toolErase: "Ластик",
      closeWaypoint: "Закрыть без сохранения",
      reverse: "Развернуть маршрут (поменять старт и финиш)",
      startLabel: "Старт",
      finishLabel: "Финиш",
      startFinishLabel: "Старт/финиш",
      discard: "Сбросить",
      keepEditing: "Продолжить",
      clearConfirm: "Очистить всё нарисованное? Это действие нельзя отменить.",
      loadError: "Не удалось загрузить маршрут для редактирования.",
      saveError: "Не удалось сохранить маршрут.",
      needTwoPoints: "Нарисуйте маршрут минимум из двух точек, прежде чем сохранять.",
      unsavedIndicator: "Есть несохранённые изменения",
      menuFile: "Файл",
      menuNew: "Новый",
      menuImport: "Импортировать",
      menuActions: "Действия",
      menuView: "Вид",
      viewStatsPanel: "Статистика",
      viewLineStyle: "Стиль линии",
      viewLineSolid: "Сплошная",
      viewLineGradient: "Градиент",
      viewDirectionArrows: "Стрелки направления",
      view3d: "3D вид",
      tabProfile: "Профиль",
      tabStats: "Статистика",
      namePlaceholder: "Введите своё название",
      profileTitle: "Высотный профиль",
      sectionsTitle: "Секции",
      addWaypointDialog: {
        typeMarker: "Метка",
        markerHint: "Личная заметка на карте - видна только вам, в «Моих метках». В маршрут не входит.",
        title: "Новая точка",
        confirm: "Добавить",
      },
      importDialog: {
        title: "Импорт маршрута",
        close: "Закрыть",
        tabMine: "Мои",
        tabFavorites: "Избранные",
        tabPublic: "Публичные",
        tabGpx: "GPX-файл",
        emptyMine: "У вас ещё нет своих маршрутов",
        emptyFavorites: "Список избранного пуст",
        emptyPublic: "Маршрутов не найдено",
        uploadButton: "Выбрать GPX-файл…",
        uploadHint: "Файл в формате GPX (.gpx)",
        importError: "Не удалось прочитать GPX-файл",
      },
      saveDialog: {
        titleNew: "Сохранить маршрут",
        titleExisting: "Сохранить изменения",
        name: "Название",
        namePlaceholder: "Например, «Кок-Жайляу через плато»",
        description: "Описание",
        descriptionPlaceholder: "Коротко о маршруте — необязательно",
        tags: "Теги",
        tagsPlaceholder: "через запятую",
        visibility: "Видимость",
        visibilityHint: "Публичный — виден всем в каталоге, приватный — только вам",
        public: "Публичный",
        private: "Приватный",
        cancel: "Отмена",
        confirm: "Сохранить",
        nameRequired: "Укажите название маршрута",
      },
    },
  },

  captive: {
    welcomeTitle: "Добро пожаловать",
    welcomeSubtitle: "Нажмите «Подключиться», чтобы выйти в интернет",
    connectButton: "Подключиться",
    defaultNodeName: "Мынжылкы",
    metersShort: "м",
    windUnit: "м/с",
    precipUnit: "мм",
    wave: {
      heading: "Передайте привет с высоты",
      body: "Камера снимет ваш момент — мы превратим его в видеооткрытку.",
      step1: "Помашите",
      step2: "Запомните время",
      step3: "Отправьте заявку",
      cta: "Получить свою открытку",
    },
    amenities: {
      title: "Геошатёр «Высота Кусто»",
      body: "Передохните, зарядите телефон и выйдите на связь.",
    },
    visitors: {
      per30days: "посетителей за 30 дней",
      today: "Сегодня",
    },
    routesLinkTitle: "Карта маршрутов рядом",
    satelliteNote: "Интернет работает через спутниковую связь. Используйте его бережно.",
  },

  tgRegister: {
    title: "Регистрация выхода",
    openInTelegram: "Откройте форму из бота",
    openInTelegramHint: "Эта страница работает только внутри Telegram: нажмите «Зарегистрировать маршрут» в боте EcoWay.",
    loading: "Загрузка…",
    authError: "Не удалось войти через Telegram. Закройте форму и откройте её из бота ещё раз.",
    retry: "Повторить",
    close: "Закрыть",
    active: {
      title: "У вас есть активная регистрация",
      extendHour: "Продлить на час",
      extended: "Контрольное время продлено",
      actionError: "Не получилось. Попробуйте ещё раз.",
    },
    returned: {
      title: "С возвращением!",
      message: "Регистрация закрыта. Хорошо, что всё в порядке.",
      newRegistration: "Новая регистрация",
    },
    success: {
      reminders: "Бот напомнит о контрольном времени возвращения — там же можно продлить его или отметиться.",
    },
  },
};
